import { render, staticRenderFns } from "./KlfsShengMing.vue?vue&type=template&id=ee5d2252&scoped=true"
import script from "./KlfsShengMing.vue?vue&type=script&lang=js"
export * from "./KlfsShengMing.vue?vue&type=script&lang=js"
import style0 from "./KlfsShengMing.vue?vue&type=style&index=0&id=ee5d2252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5d2252",
  null
  
)

export default component.exports